<template>
  <div>
    <b-button
      v-if="stage != null"
      id="show-btn"
      size="sm"
      v-b-tooltip.hover
      :title="$t('workflow.stage.editStage')"
      @click="openModal()"
    >
      <i class="tim-icons icon-pencil"></i>
    </b-button>
    <b-row v-else>
      <b-button size="sm" @click="addNewStage">
        {{ $t("workflow.stage.addStage") }}
      </b-button>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="createStage"
      :title="$t('workflow.stage.newStage')"
      size="xl"
    >
      <!-- nome -->
      <b-form-group
        :label="$t('workflow.processField.displayName')"
        label-for="displayName"
      >
        <b-form-input
          id="DisplayName"
          type="text"
          placeholder="Nome"
          v-model="newStage.displayName"
        />
      </b-form-group>
      <b-row>
        <!-- permite comentários -->
        <b-col sm="12" md="2">
          <b-form-group
            :label="$t('workflow.stage.allowComments')"
            label-for="allowComments"
          >
            <b-form-select
              id="allowComments"
              class="select-boolean"
              :options="optionsBoolean"
              v-model="newStage.allowComments"
            >
            </b-form-select>
          </b-form-group>
        </b-col>
        <!-- ivan 20220812
        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.stage.allowsViewDataFromPreviousSteps')"
            label-for="allowsViewDataFromPreviousSteps"
          >
            <b-form-select
              id="allowComments"
              class="select-boolean"
              :options="optionsBoolean"
              v-model="newStage.allowsViewDataFromPreviousSteps"
            >
            </b-form-select>
          </b-form-group>
        </b-col> -->
      </b-row>
      <!-- operador -->
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.permission.simpleOperator')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.simpleOperator"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.permission.simpleOperator')"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="optionsProfiles"
              @select="selectNewSimpleOperator"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <div>
            <label for="getFieldIdInputName">
              <b-row class="ml-auto">
                {{ $t("workflow.permission.readOnlyUsers") }}
                <b-col>
                  <b-icon
                    :title="$t('workflow.permission.readOnlyUsersTooltip')"
                    v-b-tooltip.hover
                    icon="info-circle"
                  ></b-icon>
                </b-col>
              </b-row>
            </label>
          </div>
          <div>
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.readOnlyUsers"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.permission.readOnlyUsers')"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="optionsProfiles"
              @select="selectNewReadOnlyUser"
            >
            </multiselect>
          </div>
        </b-col>

        <!-- ivan 20220826
        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.permission.advancedOperator')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.advancedOperator"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.permission.advancedOperator')"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="optionsProfiles"
            >
            </multiselect>
          </b-form-group> -->
        <!-- </b-col> -->
      </b-row>

      <!-- Notificação por e-mail -->
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.notifySimpleOperators')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <single-select
              id="input-form-profile-fill"
              :value.sync="newStage.notifySimpleOperators"
              :value-property="'value'"
              label="text"
              :placeholder="$t('workflow.notifySimpleOperators')"
              :options="optionsNotifications"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" md="4">
          <div>
            <label for="getFieldIdInputName">
              <b-row class="ml-auto">
                {{ $t("workflow.notifyReadOnlyOperators") }}
                <b-col>
                  <b-icon
                    :title="$t('workflow.notifyReadOnlyOperatorsTooltip')"
                    v-b-tooltip.hover
                    icon="info-circle"
                  ></b-icon>
                </b-col>
              </b-row>
            </label>
          </div>
          <div>
            <single-select
              id="input-form-profile-fill"
              :value.sync="newStage.notifyReadOnlyOperators"
              :placeholder="$t('workflow.notifyReadOnlyOperators')"
              :value-property="'value'"
              :options="optionsNotifications"
            />
          </div>
        </b-col>

        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.notifyGestors')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <single-select
              id="input-form-profile-fill"
              :value.sync="newStage.notifyGestors"
              :value-property="'value'"
              label="text"
              :placeholder="$t('workflow.notifyGestors')"
              :options="optionsNotifications"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- campo de ordeação -->
        <b-col sm="12" md="4">
          <!-- {{ sortField }} -->
          <!-- {{ newStage.sortField }} -->
          <b-form-group
            :label="$t('workflow.stage.sortField')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <single-select
              :value.sync="newStage.sortField"
              :value-property="'value'"
              :placeholder="$t('workflow.stage.sortField')"
              :options="getSortField"
            >
            </single-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            :label="$t('workflow.stage.responsableField')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <single-select
              :value.sync="newStage.responsableFieldId"
              :value-property="'value'"
              :placeholder="$t('workflow.stage.responsableField')"
              :options="getResponsableFields"
            >
            </single-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="3">
          <!-- {{ newStage.stageType }} -->
          <!-- {{ stageType }} -->
          <b-form-group
            :label="$t('workflow.stage.stageType')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="stageType"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.stage.stageType')"
              :close-on-select="true"
              :showLabels="false"
              :multiple="false"
              :options="stageTypeOpt"
              @input="onChange"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="3" v-if="isObtainingData">
          <!-- {{ obtainingData }} -->
          <!-- {{ stage.obtainingDataType }} -->
          <b-form-group
            :label="$t('workflow.stage.typeOfObtainingData')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="obtainingData"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.stage.typeOfObtainingData')"
              :close-on-select="true"
              :showLabels="false"
              :multiple="false"
              :options="obtainingDataOpt"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <!-- <b-col sm="12" md="2" v-if="chooseProfile">
          <b-form-group
            :label="$t('workflow.stage.responsibleProfile')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.obtainingDataProfiles"
              label="text"
              track-by="value"
              placeholder="Perfil"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="optionsProfiles"
            >
            </multiselect>
          </b-form-group>
        </b-col> -->

        <b-col sm="12" md="2" v-if="chooseReponsibleField">
          <!-- {{ newStage.obtainingDataFieldList }} -->
          <b-form-group
            :label="$t('workflow.stage.responsibleField')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.obtainingDataFieldList"
              label="text"
              track-by="value"
              placeholder="Campo"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="obtainingDataField"
            >
            </multiselect>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="2" v-if="chooseReponsibleField">
          <!-- {{ obtainingDataStage }} -->
          <!-- {{ newStage.obtainingDataStageList }} -->
          <b-form-group
            :label="$t('workflow.stage.stageInUse')"
            label-for="input-form-profile-fill"
            class="mb-4"
          >
            <multiselect
              id="input-form-profile-fill"
              v-model="newStage.obtainingDataStageList"
              label="text"
              track-by="value"
              :placeholder="$t('workflow.stage.stageInUse')"
              :close-on-select="false"
              :showLabels="false"
              :multiple="true"
              :options="obtainingDataStage"
            >
            </multiselect>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="newStage && newStage.stageType == 1">
        <stage-crud-fields :process="process" :stage="newStage">
        </stage-crud-fields>
      </div>

      <!-- {{ newStage }} -->
      <!-- <pre class="language-json"><code>stages: {{ process.stages  }}</code></pre> -->
      <!-- <pre class="language-json"><code>model: {{ newStage  }}</code></pre> -->
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button class="ml-2" variant="green" @click="addStage()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- <div>{{ optionsProfiles }}</div> -->
  </div>
</template>
<script>
import StageSequenceControl from "./StageSequenceControl";
export default {
  name: "StageModal",
  props: {
    process: Object,
    stages: Array,
    tableRows: Array,
    stage: Object
  },
  components: {
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
    StageCrudFields: () =>
      import("@/components_rms/workflow/StageCrud/StageCrudFields.vue")
  },
  mixins: [StageSequenceControl],
  data() {
    return {
      newStage: {},
      optionsBoolean: [
        {
          value: true,
          text: "Sim"
        },
        {
          value: false,
          text: "Não"
        }
      ],
      optionsProfiles: [],
      optionsNotifications: [
        {
          value: 0,
          text: "Não notificar"
        },
        {
          value: 1,
          text: "Notificar por e-mail"
        }
      ],
      sortField: { value: "", text: "" },
      stageTypeOpt: [
        { value: 1, text: "Torre" },
        { value: 2, text: "Obtenção de dados / cadastro" }
      ],
      stageType: { value: 1, text: "Torre" },
      isObtainingData: false,
      obtainingDataOpt: [
        // { value: 1, text: "Pessoa" },
        { value: 2, text: "Veículo" },
        { value: 3, text: "Motorista" }
      ],
      obtainingData: "",
      chooseReponsibleField: false,
      obtainingDataField: [],
      obtainingDataStage: [],
      chooseProfile: false
      // allProfiles: [],
    };
  },
  created() {
    if (this.stage != null) {
      this.newStage = this.stage;
      //StageType
      if (this.stage.stageType == 2) {
        this.stageType = { value: 2, text: "Obtenção de dados / cadastro" };
        this.isObtainingData = true;
      } else this.stageType = { value: 1, text: "Torre" };
      // DataType
      if (this.stage.obtainingDataType == 3) {
        this.chooseReponsibleField = true;
        this.obtainingData = { value: 3, text: "Motorista" };
        this.getObtainDataDropdown();
      } else if (this.stage.obtainingDataType == 2) {
        this.chooseReponsibleField = true;
        this.obtainingData = { value: 2, text: "Veículo" };
        this.getObtainDataDropdown();
      }
    }
    this.loadOptionsProfiles();
  },
  computed: {
    getResponsableFields() {
      if (!this.process) return [];
      if (!this.process.fields) return [];
      let responsableFields = [];
      this.process.fields.forEach(field => {
        if (field.type > 9000) {
          // Integração
          responsableFields.push({ value: field.id, text: field.displayName });
        } else {
          switch (field.type) {
            case 14: // Responsável
              responsableFields.push({
                value: field.id,
                text: field.displayName
              });
              break;
            case 21: // Motorista
              responsableFields.push({
                value: field.id,
                text: field.displayName
              });
              break;
          }
        }
      });
      return responsableFields;
    },
    getSortField() {
      if (!this.process) return [];
      if (!this.process.fields) return [];
      let sortField = [];
      if (this.process.fields) {
        this.process.fields.forEach(field => {
          sortField.push({ value: field.id, text: field.displayName });
        });
      }
      return sortField;
    }
    // listSimpleOperators() {
    //   if (!this.newStage) return [];
    //   if (!this.newStage.simpleOperator) return [];
    //   return [];
    // },
    // listReadOnlyUsers() {
    //   return [];
    // },
  },
  methods: {
    openModal() {
      this.$refs.createStage.show();
    },
    addTableRow(stage) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        stage: stage
      });
    },
    addNewStage() {
      this.newStage = {
        id: this.generateUUID(),
        active: true,
        sequenceNumber: this.getNextSequenceNumber(this.stages),
        allowComments: false,
        allowsViewDataFromPreviousSteps: false,
        scriptPython: "",
        validationScript: "",
        displayName: "",
        stageType: 1,
        obtainingDataType: 0,
        backgroundServiceScript: "",
        obtainingDataFieldList: [],
        obtainingDataStageList: [],
        obtainingDataProfiles: [],
        simpleOperator: [],
        readOnlyUsers: [],
        advancedOperator: [],
        nextStage: [],
        fields: [],
        summaryFields: [],
        cardFields: []
      };
      this.openModal();
      this.stages.push(this.newStage);
      this.addTableRow(this.newStage);
      this.$forceUpdate();
    },
    addStage() {
      this.$refs.createStage.hide();
    },
    onChange(value) {
      if (value) {
        this.newStage.stageType = value.value;
      } else {
        this.newStage.stageType = "";
      }
      if (this.newStage.stageType == 2) this.isObtainingData = true;
      else {
        this.isObtainingData = false;
        this.chooseReponsibleField = false;
        this.chooseProfile = false;
      }
    },
    onChangeObtainingData(value) {
      if (value.value != this.newStage.obtainingData) {
        this.newStage.obtainingDataFieldList = [];
        // this.newStage.obtainingDataStageList = [];
      }
      if (value) {
        this.newStage.obtainingDataType = value.value;
      } else {
        this.newStage.obtainingDataType = "";
      }
      this.getObtainDataDropdown();
      this.chooseReponsibleField = true;
    },
    selectNewSimpleOperator(selectedOption) {
      this.unselectNewReadOnlyUser(selectedOption);
      // this.newStage
    },
    selectNewReadOnlyUser(selectedOption) {
      this.unselectSimpleOperator(selectedOption);
    },
    unselectSimpleOperator(option) {
      if (!this.newStage) return;
      if (!this.newStage.simpleOperator) return;

      for (let i = this.newStage.simpleOperator.length - 1; i >= 0; i--) {
        if (this.newStage.simpleOperator[i].value == option.value) {
          this.newStage.simpleOperator.splice(i, 1);
          break;
        }
      }
    },
    unselectNewReadOnlyUser(option) {
      if (!this.newStage) return;
      if (!this.newStage.readOnlyUsers) return;

      for (let i = this.newStage.readOnlyUsers.length - 1; i >= 0; i--) {
        if (this.newStage.readOnlyUsers[i].value == option.value) {
          this.newStage.readOnlyUsers.splice(i, 1);
          break;
        }
      }
    },
    getObtainDataDropdown() {
      if (this.process.fields) {
        this.obtainingDataField = [];
        this.process.fields.forEach(field => {
          if (this.obtainingData.value == 3 && field.type == 21) {
            this.chooseProfile = true;
            this.obtainingDataField.push({
              value: field.id,
              text: field.displayName
            });
          } else if (this.obtainingData.value == 2 && field.type == 20) {
            this.chooseProfile = false;
            this.obtainingDataField.push({
              value: field.id,
              text: field.displayName
            });
          }
        });
      }
      if (this.process.stages) {
        this.process.stages.forEach(stage => {
          this.obtainingDataStage.push({
            value: stage.id,
            text: stage.displayName
          });
        });
      }
    },
    loadOptionsProfiles() {
      this.$apiScheduler.get("/profile/getCompanyProfiles/").then(response => {
        response.data.forEach(x => {
          this.optionsProfiles.push({
            value: x.id,
            text: x.displayName
          });
        });
      });
    }
  }
};
</script>
